import { useState, useLayoutEffect, useRef } from 'react';

// Tracks the rendered size of an element. Use this rather than useWindowDimensions
// when something has to match its own box exactly: on mobile the window size and
// the size of a 100dvh element disagree, because window.innerHeight and the
// browser's idea of the viewport treat the address bar differently. Sizing an
// svg viewBox off the window instead of the box it is drawn into leaves the two
// aspect ratios mismatched, which preserveAspectRatio then resolves by either
// cropping or letterboxing.
export default function useElementSize() {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize({ width, height });
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, size];
}
